import * as React from 'react';
import { classes } from '../../../utils/Classes';
import { FilterItemWrapper } from '../FilterItemWrapper';
import { translate } from 'elc-service';

export interface IClearAllFilters {
    onClick(): void;
    className?: string;
    translations?: IClearAllFiltersTranslations;
}

interface IClearAllFiltersTranslations {
    clearFiltersLabel: string;
}

@translate(['clearFiltersLabel'])
export class ClearAllFilters extends React.Component<IClearAllFilters> {
    render() {
        const clearAllButtonClassnames = classes(
            'styled-filters-clear-all-button',
            this.props.className
        );
        const { clearFiltersLabel } = this.props.translations as IClearAllFiltersTranslations;

        return (
            <FilterItemWrapper
                className={clearAllButtonClassnames}
                onClick={this.props.onClick}
                ariaLabel={clearFiltersLabel}
            >
                {clearFiltersLabel}
            </FilterItemWrapper>
        );
    }
}
